<template>
  <div class="header">
    <div class="content-wrapper">
      <div style="display: flex; align-items: flex-start">
        <!-- <div class="avatar"> -->
        <router-link to="/index" class="avatar">
          <img
            style="width: 70px; border-radius: 3px"
            src="@/assets/logo.png"
          />
        </router-link>
        <!-- <a href="">
            <img
              style="width: 80px; border-radius: 3px"
              src="@/assets/logo.png"
            />
          </a> -->
        <!-- </div> -->
        <div class="content">
          <div class="title">
            <h2 class="name">路竹大立超市</h2>
          </div>
          <div
            class="description"
            style="
              text-align: left;
              font-size: 0.9rem;
              font-weight: 500;
              letter-spacing: 1.5px;
            "
          >
            07-6978265
          </div>
          <!-- <div v-if="seller.supports" class="support">
          <support-ico :size="1" :type="seller.supports[0].type"></support-ico>
          <span class="text"></span>
        </div> -->
        </div>
      </div>
      <!-- <div class="cart">
        <router-link :to="{ path: '/cart' }">
          <i class="fas fa-shopping-cart"></i>
        </router-link>
      </div> -->
      <!-- <div v-if="seller.supports" class="support-count">
        <span class="count">个</span>
        <i class="icon-keyboard_arrow_right"></i>
      </div> -->
    </div>

    <div class="navbar">
      <button onclick="location.href='https://dali-mart.com/'"><i class="fas fa-home"></i> 首頁</button>
      <router-link
        to="/index"
        tag="button"
        :class="{ active: nowRoute == '/index' }"
        ><i class="fas fa-store"></i> 商城</router-link
      >
      <router-link
        to="/status"
        tag="button"
        :class="{ active: nowRoute == '/status' }"
        ><i class="fas fa-clipboard-list"></i> 訂單狀態</router-link
      >
      <!-- <button type="button" @click="linelogin">
        <i class="fab fa-line"></i> 登入
      </button> -->
    </div>
    <!-- <div class="bulletin-wrapper">
      <span class="bulletin-title">公告</span
      ><span class="bulletin-text"
        >公告內容公告內容公告內容公告內容公告內容公告內容公告內容公告內容公告內容公告內容</span
      >
    </div> -->
  </div>
</template>

<script>
// import $ from 'jquery';

export default {
  data() {
    return {
      nowRoute: '',
      user_name: '',
      user_avator: '',
      user_id: '',
    };
  },
  created() {
    // const vm = this;
    // console.log(this.$route.path);
    this.nowRoute = this.$route.path;
    // console.log(this.$route.query);

    // if (this.$cookies.get('access_token')) {
    //   // 驗證如果登入過

    //   // $.ajax({
    //   //   url: 'https://api.line.me/oauth2/v2.1/verify',
    //   //   type: 'GET',
    //   //   data: {
    //   //     access_token: `${vm.$cookies.get('access_token')}`,
    //   //   },
    //   //   success(res) {
    //   //     console.log('是否能用', res);
    //   //   },
    //   // });

    //   $.ajax({
    //     url: 'https://api.line.me/v2/profile',
    //     type: 'GET',
    //     headers: {
    //       Authorization: `Bearer ${vm.$cookies.get('access_token')}`,
    //     },
    //     success(user) {
    //       console.log(user);
    //       if (user.displayName === '' || user.pictureUrl === '' || user.userId === '') {
    //         vm.$cookies.remove('access_token');
    //       } else {
    //         vm.user_name = user.displayName;
    //         vm.user_avator = user.pictureUrl;
    //         vm.user_id = user.userId;
    //       }
    //     },
    //   });
    // }

    // if (this.$route.query.code) {
    //   // 取得code query
    //   console.log(vm.$route.query.code, process.env.VUE_APP_URL);
    //   $.ajax({
    //     url: 'https://api.line.me/oauth2/v2.1/token',
    //     type: 'POST',
    //     contentType: 'application/x-www-form-urlencoded',
    //     data: {
    //       grant_type: 'authorization_code',
    //       client_id: process.env.VUE_APP_LINECLIENTID,
    //       client_secret: 'c276aca1fd5bf3b620fca8927e8be18e',
    //       code: vm.$route.query.code,
    //       redirect_uri: process.env.VUE_APP_URL,
    //     },
    //     success(res) {
    //       console.log(res);
    //       if (res.access_token) {
    //         vm.$cookies.set('access_token', res.access_token);
    //         $.ajax({
    //           url: 'https://api.line.me/v2/profile',
    //           type: 'GET',
    //           headers: {
    //             Authorization: `Bearer ${res.access_token}`,
    //           },
    //           success(user) {
    //             console.log(user);
    //             vm.user_name = user.displayName;
    //             vm.user_avator = user.pictureUrl;
    //             vm.user_id = user.userId;
    //             vm.$router.push('/');
    //             // $('#name').append(res.displayName);
    //             // $('#avator').attr('src', res.pictureUrl);
    //           },
    //         });
    //         // $.ajax({
    //         //   url: 'https://api.line.me/oauth2/v2.1/verify',
    //         //   type: 'POST',
    //         //   contentType: 'application/x-www-form-urlencoded',
    //         //   data: {
    //         //     id_token: res.id_token,
    //         //     client_id: process.env.VUE_APP_LINECLIENTID,
    //         //   },
    //         //   success(userinfo) {
    //         //     console.log(userinfo);

    //         //     vm.user_name = userinfo.name;
    //         //     vm.user_avator = userinfo.picture;
    //         //     vm.user_id = userinfo.sub;
    //         //     vm.user_email = userinfo.email;
    //         //     // $('#email').append(res.email);
    //         //     // const exp = new Date(res.exp * 1000);
    //         //     // const iat = new Date(res.iat * 1000);
    //         //     console.log(new Date(userinfo.exp * 1000));
    //         //     console.log(new Date(userinfo.iat * 1000));
    //         //     // $('#exp').append(exp);
    //         //     // $('#iat').append(iat);
    //         //   },
    //         // });
    //       }
    //     },
    //   });
    // }
  },
  methods: {
    linelogin() {
      // 取得query
      // const clientId = process.env.VUE_APP_LINECLIENTID;
      // const redirectUri = process.env.VUE_APP_URL;
      // let link = 'https://access.line.me/oauth2/v2.1/authorize?';
      // link += 'response_type=code';
      // link += `&client_id=${clientId}`;
      // link += `&redirect_uri=${redirectUri}`;
      // link += '&state=login';
      // link += '&scope=profile%20openid%20email';
      // window.location.href = link;
    },
  },
};
</script>

<style lang="scss">
</style>
